import styled from 'styled-components';
const UserDetailsWrapper = styled.div`
.userDetailsComponent  {
  .ant-modal-content{
    border-radius:10px;
}
      header{
        border-bottom:1.75px solid #e0e3ee;
        padding:20px 0 10px;
        text-align: center;
          h1{
              font-size:0.9rem;
              color: #344177;
              font-weight: normal;
              text-transform: capitalize;
              font-weight: 500;
              margin:0;
              padding:0 0 5px;
          }
          .name,.phone{
              font-family:"open sans", sans-serif;
              font-size: 0.9rem;
              color: #344177;
              font-weight: normal;
              text-transform: capitalize;
              font-weight: bold;
              margin:0;
              padding:0;  
          }
    }
    .dropdownMenu{
      .ant-popover-inner{
        border-radius:10px;
    }
      .ant-form-item{
        margin:0;
    }
    >h1{
    font-family:"open sans", sans-serif;
    font-size: 0.75rem;
    color: #344177;
    font-weight: normal;
    text-transform: capitalize;
    font-weight: normal;
    margin:0;
    padding: 10px 0 10px;    
    }

    ul{
      margin:0;
      list-style:none;
      padding:0;
      li{
          border-bottom:1.75px dashed #e0e3ee;
          padding:5px 0;
          &:last-child{
              border:0;
          }

           .note{
                    font-size:0.9rem;
                    font-weight: normal;
                    line-height: normal;
                    font-style: italic;
                    margin: 5px 0 0;
                    padding: 0;
                    color:#b2b9d6;
                  }

                  .message-text{
                      margin:10px 0 0;
                      .ant-form-item{
                          margin:0;
                      }
                    textarea{
                        font-family:"open sans", sans-serif;
                        border-radius: 10px;
                        line-height: normal;;
                        border: solid 0.4px #b2b9d6;
                        background-color: #ffffff;
                        height: 60px;
                        padding:10px;
                        resize: none;
                        &:focus{
                            outline:none;
                            box-shadow: none;
                        }
                      }
                  }


      .list-content{
        display: flex;
        align-items: center;
        justify-content: space-between;
       
        >h1{
            font-family:"open sans", sans-serif;
            font-size:0.9rem;
            color: #344177;
            font-weight: bold;
            text-transform: capitalize;
            font-weight: bold;
            margin:0;
            padding:0;  
          }
         
          .button{
            font-family:"open sans", sans-serif;
            cursor: pointer;
            line-height: normal;
            max-width: 64px;
            min-width: 64px;
            height: 25px;
            font-size: 0.75rem;
            border: 0;
            border-radius: 25px;
            display: block;
            text-transform: uppercase;
            text-align: center;
            color: #ffffff;
            font-weight: bold;
            line-height: 1;
            &.available{
                background:#8ec93d;
            }
            &.on-other-call{
                background:#f6c933;
            }
            &.busy{
                background:#d05353;
            }
          }
      }
      .note{
        font-size:0.9rem;
        font-weight: normal;
        line-height: normal;
        font-style: italic;
        margin: 5px 0 0;
        padding: 0;
        color:#b2b9d6;
      }

      .message-text{
          margin:10px 0 0;
          .ant-form-item{
              margin:0;
          }
        textarea{
            font-family:"open sans", sans-serif;
            border-radius: 10px;
            line-height: normal;;
            border: solid 0.4px #b2b9d6;
            background-color: #ffffff;
            height: 60px;
            padding:10px;
            resize: none;
            &:focus{
                outline:none;
                box-shadow: none;
            }
          }
      }
    }
  }
  footer{
    padding: 10px 0 0;
    margin:10px 0 0;
    border-top:1.75px solid #e0e3ee;
      .logoutbtn{
        background: none;
        color: #344177;
        border: 0;
        box-shadow: none;
        font-weight: 500;
        padding: 0;
        font-size: 0.9rem;
      }
  }
    }
  }


`;


export default (UserDetailsWrapper);